'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

export const ClimatePledgeFriendlySection = () => {
  const t = useTranslations('ldp_amazon_hardcode.climate_pledge')

  return (
    <CollectionContainer className='my-8 px-5 md:my-16 md:px-16'>
      <div className='flex flex-col items-center gap-4 md:flex-row md:gap-12'>
        <div className='w-full md:w-1/2'>
          <Image
            src={ImageHelper.getImageUrlCdn(
              '/image/September2025/mceclip10_9.jpg'
            )}
            alt={t('title')}
            width={500}
            height={350}
            className='h-auto w-full rounded-lg object-cover'
          />
        </div>
        <div className='flex w-full flex-col justify-center md:w-1/2'>
          <div className='font-criteria text-3xl font-semibold text-black md:text-5xl 2xl:text-[65px] 2xl:leading-tight'>
            {t.rich('title', {
              newline: () => <br className='hidden md:block' />,
            })}
          </div>
          <p className='mt-4 font-criteria text-base text-primary-500 md:text-xl'>
            {t('subtitle')}
          </p>
          <p className='mt-4 text-base text-neutral-800 md:mt-8'>
            {t.rich('description', {
              bold: (chunks) => <span className='font-semibold'>{chunks}</span>,
            })}
          </p>
          <div className='mt-6 md:mt-8'>
            <Link
              href='https://media3.coolmate.me/uploads/videos/amazon_pdf.pdf'
              target='_blank'
              className='flex items-center gap-2 text-sm text-primary-500 underline md:text-base'
            >
              <Image
                src={ImageHelper.getImageUrlCdn(
                  '/image/October2025/mceclip7.png'
                )}
                alt={t('certificate_link')}
                width={50}
                height={50}
                className='h-6 w-6'
              />
              {t('certificate_link')}
            </Link>
          </div>
        </div>
      </div>
    </CollectionContainer>
  )
}
